import { render, staticRenderFns } from "./attention-list.vue?vue&type=template&id=1dc8c2ad&scoped=true"
import script from "./attention-list.vue?vue&type=script&lang=js"
export * from "./attention-list.vue?vue&type=script&lang=js"
import style0 from "./attention-list.vue?vue&type=style&index=0&id=1dc8c2ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8c2ad",
  null
  
)

export default component.exports